import React, { useState } from "react";
import { Box, Grid, styled, Typography } from "@mui/material";
import { Text, Title } from "./style";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import GstIcon from "../../images/landing/gst icon.png";
import ReportsIcon from "../../images/landing/reports icon.png";
import BillingIcon from "../../images/landing/billing icon.png";
import StoreIcon from "../../images/store icon.svg";
import InvoiceIcon from "../../images/landing/invoice icon.png";
import QuoteIcon from "../../images/landing/quote icon.png";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

const RootStyle = styled(Box)(({ theme }) => ({
  minHeight: "90vh",
  background: "#FAFAFA",
  padding: "50px 83px",
  [theme.breakpoints.down("md")]: {
    padding: "30px 15px",
  },
}));

const ItemBox = styled(Box)((props) => ({
  height: "50px",
  display: "flex",
  alignItems: "center",
  columnGap: "16px",
  background: props.sel ? "#FBF8DB" : "#FFFFFF",
  cursor: "pointer",
  borderRadius: "8px",
  marginBottom: "8px",
}));
const SubTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "20px",
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "19px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "16spx",
  },
}));

function FeaturesSection() {
  const [selected, setSelected] = useState("quotation");

  const handleSelect = (title) => {
    setSelected(title);
  };
  return (
    <RootStyle>
      <Title sx={{ my: 5, textAlign: "center" }}>Features of ManageKaro </Title>

      <Grid container spacing={2}>
        <Grid item md={6} xs={12}>
          <ItemBox
            sel={selected == "quotation" ? true : false}
            onClick={() => handleSelect("quotation")}
          >
            <img height="40px" src={QuoteIcon} alt="" />
            <SubTitle>Create Quotations</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "expenses" ? true : false}
            onClick={() => handleSelect("expenses")}
          >
            <MonetizationOnOutlinedIcon
              sx={{ color: "#4CAF50", fontSize: "40px" }}
            />
            <SubTitle>Record Expenses</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "reports" ? true : false}
            onClick={() => handleSelect("reports")}
          >
            <img height="40px" src={ReportsIcon} alt="" />
            <SubTitle>Generate Reports</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "invoice" ? true : false}
            onClick={() => handleSelect("invoice")}
          >
            <img height="40px" src={InvoiceIcon} alt="" />
            <SubTitle>Create Invoice</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "gst" ? true : false}
            onClick={() => handleSelect("gst")}
          >
            <img height="40px" src={GstIcon} alt="" />
            <SubTitle>GST Billing</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "backup" ? true : false}
            onClick={() => handleSelect("backup")}
          >
            <CloudUploadOutlinedIcon
              sx={{ color: "#4CAF50", fontSize: "40px" }}
            />
            <SubTitle>Automatic Data Backup</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "print" ? true : false}
            onClick={() => handleSelect("print")}
          >
            <PrintOutlinedIcon sx={{ color: "#4CAF50", fontSize: "40px" }} />
            <SubTitle>Regular / Thermal Printer</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "billing" ? true : false}
            onClick={() => handleSelect("billing")}
          >
            <img height="40px" src={BillingIcon} alt="" />
            <SubTitle>Online Billing Web App</SubTitle>
          </ItemBox>
          <ItemBox
            sel={selected == "store" ? true : false}
            onClick={() => handleSelect("store")}
          >
            <img height="40px" src={StoreIcon} alt="" />
            <SubTitle>Online Store</SubTitle>
          </ItemBox>
        </Grid>
        <Grid item md={6} xs={12}>
          {selected == "quotation" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Create Quotation</SubTitle>
              <Text sx={{ mb: 2 }}>
                ManageKaro offers a comprehensive solution for creating,
                managing, and sending quotations to customers.
              </Text>
              <Text sx={{ mb: 2 }}>
                Quotation Creation: You can easily create quotations using
                ManageKaro's platform. This feature includes customizable
                templates to input relevant details such as products/services
                offered, pricing, terms and conditions.
              </Text>
              <Text sx={{ mb: 2 }}>
                Sending Quotes: The platform allows you to send quotes directly
                to customers via WhatsApp, ensuring quick and convenient
                communication. Additionally, the option to print quotes is also
                available for traditional documentation purposes.
              </Text>
              <Text sx={{ mb: 2 }}>
                Professional Outlook: ManageKaro provides a professional
                appearance for your quotes and estimates, enhancing the
                credibility and impression on customers. This involves
                standardized formatting and professional templates.
              </Text>
              <Text sx={{ mb: 2 }}>
                Error-Free Quotes: By using inbuilt features, ManageKaro ensures
                that the quotes generated are accurate and error-free, reducing
                potential misunderstandings or discrepancies with customers.
              </Text>
              <Text sx={{ mb: 2 }}>
                Conversion to Invoices/Bills: You can also seamlessly convert
                estimates and quotations into finalised sale invoices or bills.
                This feature streamlines the process of moving from initial
                quotes to final transactions.
              </Text>
            </Box>
          )}
          {selected == "expenses" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Record Expenses</SubTitle>
              <Text sx={{ mb: 2 }}>
                Tracking and recording all expenses in the business is very
                important for accounting and tax filing. It is very easy to
                follow the money spent and create an accurate report with
                ManageKaro. Our Web and Mobile apps are an efficient option for
                recording expenses. Businesses can easily optimise their
                expenditure to save money and record both GST and non-GST
                expenses.
              </Text>
              <Text>
                Furthermore, ManageKaro billing solutions comes with various
                benefits over competitors. It helps you reduce costs and
                maximise sales with advanced analytics on the amount spent, cash
                received and ledger updates. This is an efficient option for
                quickly recording outstanding expenses while making entries in
                the ledgers and daybook. Our mobile apps (iOS & Android) are
                suitable for growing businesses by helping keep their finances
                in check and increasing profitability.
              </Text>
            </Box>
          )}
          {selected == "reports" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Generat Reports</SubTitle>
              <Text sx={{ mb: 2 }}>
                Businesses are required to make informed decisions to ensure a
                consistent growth trajectory. Reports created using our
                ManageKaro for all your business requirements show immense
                growth potential. Using ManageKaro extensively increases your
                business’s operational efficiency as you can easily export the
                reports in PDF.
              </Text>
              <Text>
                 Users can easily view and analyse the data instantly.
                ManageKaro analyses accurate business details, sales, bills,
                supplier purchases, balance sheet, ledgers, stock, profit loss,
                sales return and much more; it is also an efficient way to
                quickly analyse the business’s profit.
              </Text>
            </Box>
          )}
          {selected == "invoice" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Create Invoice</SubTitle>
              <Text sx={{ mb: 2 }}>
                We understand that sending invoices is a vital aspect of any
                business. You need to maintain a positive cash flow and timely
                invoice payments for the smooth running of your business. Our
                online invoice tool enables you to receive payments from your
                customers without any hassle.
              </Text>
              <Text>
                ManageKaro enables businesses to create and customise the
                invoices per their unique requirements. You can use the app to
                generate GST invoices for your clients within a few clicks and
                print/share them with customers. With the help of this feature,
                it is easier to track all the due dates in the invoices and
                organise them chronologically. This enables businesses to
                identify any overdue payments instantly.
              </Text>
            </Box>
          )}
          {selected == "store" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Online Store</SubTitle>
              <Text sx={{ mb: 2 }}>
                Set up your online e-commerce store instantly using ManageKaro.
                Using our mobile and web apps, you can list all the
                services/products you sell to your customers online via a
                dedicated website link, and it will help you present a catalogue
                of all the services/products you offer, enabling you to generate
                sales online. This will reduce your cost of selling items, while
                increasing revenue and profitability.
              </Text>
              <Text>
                It helps in increasing the sales, and hence the growth of your
                business. Using ManageKaro, you can update your online store
                anytime and target more customers all around Pakistan by taking
                your business online in just a few clicks.
              </Text>
            </Box>
          )}
          {selected == "gst" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Gst Billing</SubTitle>
              <Text sx={{ mb: 2 }}>
                Our all-in-one billing feature is an excellent addition to your
                business as it helps you automate your billing requirements. It
                is very efficient in maintaining completed and outstanding
                bills. With the help of ManageKaro, business owners can perform
                various tasks, including sales return, inventory management,
                invoicing, and billing. You can use the barcode scanner to speed
                up your billing process, and avoid long queues at the cash
                counter.
              </Text>
              <Text>
                With the help of these features, it is very easy to track all
                the due dates in the outstanding bills or track old bills.
                Accessing this data on the mobile with notifications means you
                never miss a payment deadline.
              </Text>
            </Box>
          )}
          {selected == "backup" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Automatic Data Backup</SubTitle>
              <Text sx={{ mb: 2 }}>
                ManageKaro 100% secure, and you can easily store your data
                accurately. Our Web App lets you keep your data secure by
                creating cloud backups. The data is encrypted with added
                security. ManageKaro comes with auto-backup so you don’t have to
                worry about manual backups. A lot of businesses in Pakistan have
                used ManageKaro to make the job quick with added data security.
              </Text>
              <Text>
                Advanced Encryption system that allows it to keep the data
                accessible to the owner only to enhance security further. Anyone
                in the ManageKaro team cannot use your business data, and thus
                it makes your data secure for future reference.
              </Text>
            </Box>
          )}
          {selected == "print" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Regular / Thermal Printer</SubTitle>
              <Text sx={{ mb: 2 }}>
                We understand that printing invoices and bills for customers
                needs to be extremely efficient and quick to avoid long queues.
                On ManageKaro, the entire process from creating a bill to
                printing it is seamless and can be completed within seconds. You
                can use regular and thermal printers to print the invoices/bills
                or quotations and hand them over to clients.
              </Text>
              <Text>
                ManageKaro is compatible with thermal and regular (laser)
                printers and can help you get your desired printout within
                minutes. It offers the most efficient way to print your
                Invoices, Quotations or Bills. You also have the option to
                quickly generate the prints in all suitable size options,
                including regular paper size A4 & A5, thermal paper size 2” &
                3”, and other custom paper size options. You can use our Web and
                Mobile Apps to create and send professional invoices and bills
                to your customers.
              </Text>
            </Box>
          )}
          {selected == "billing" && (
            <Box>
              <SubTitle sx={{ my: 1.8 }}>Online Store</SubTitle>
              <Text sx={{ mb: 2 }}>
                Set up your online store fast using the ManageKaro Web App.
                Using our mobile / web app, you can list all the
                services/products you sell to your customers online, and it will
                help you present a catalogue of all the services/products you
                sell and boost your sales online. Using ManageKaro features for
                your business will help you reduce waiting time, generate and
                analyse better reports and boost sales.
              </Text>
              <Text>
                It helps increase the sales, and hence the growth of the
                business. Using the GST billing software, you can update your
                online store anytime. You can bring in more customers in your
                locality by taking your business online using the ManageKaro.
              </Text>
            </Box>
          )}
        </Grid>
      </Grid>
    </RootStyle>
  );
}

export default FeaturesSection;
